import {FormLabelProps} from '@chakra-ui/react';
import React, {memo} from 'react';
import {UiFormLabel} from '../elements';

interface Props extends FormLabelProps {
  children: React.ReactNode;
}

const StudentFormLabel = ({children, ...rest}: Props) => {
  return (
    <UiFormLabel fontWeight="400" fontSize="md" color="graySecondary" {...rest}>
      {children}
    </UiFormLabel>
  );
};

export default memo(StudentFormLabel);
